var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { CodeListing } from './code';
function textContent(node) {
    return node.children
        .map((child) => (child.type === 'text' ? child.value : child.type == 'element' ? textContent(child) : ''))
        .join('');
}
export function Markdown({ children }) {
    return (_jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], components: {
            pre: (_a) => {
                var { node } = _a, rest = __rest(_a, ["node"]);
                let language;
                if ((node === null || node === void 0 ? void 0 : node.type) === 'element' &&
                    node.tagName === 'pre' &&
                    node.children.length >= 1 &&
                    node.children[0].type === 'element' &&
                    node.children[0].tagName === 'code') {
                    const codeNode = node.children[0];
                    if (Array.isArray(codeNode.properties.className)) {
                        for (const className of codeNode.properties.className) {
                            if (typeof className === 'string' && className.startsWith('language-')) {
                                language = className.replace(/^language-/, '');
                                break;
                            }
                        }
                    }
                }
                const code = node ? textContent(node) : '';
                return _jsx(CodeListing, Object.assign({ code: code, language: language }, rest, { className: "mt-6" }));
            }
        }, children: children }));
}
